"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$ldClient = void 0;
const nanostores_1 = require("nanostores");
/**
 * The LD client hooks read from. `undefined` until the first client has settled (initialised or
 * failed). When consent is granted the previous client stays here until its replacement settles,
 * so flag-gated UI doesn't blink back to default values. When consent is revoked the replacement
 * is published immediately with `settled: false`, so the events-enabled client stops at once, then
 * re-published as a new entry with `settled: true` once it settles, so hooks re-read its flags.
 */
exports.$ldClient = (0, nanostores_1.atom)(undefined);
